import { Text } from '@mantine/core';
import { Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';

export const ReturnToLoginLink = () => (
  <Text component="p" mt="auto" c="gray" size="xs">
    Already have account?{' '}
    <Anchor component={Link} to="/login">
      Log in
    </Anchor>
  </Text>
);
